import { IELTS_MODAL_HIDE, IELTS_MODAL_SHOW, typeActionCreator } from '@applyboard/ab-common';
export var ieltsModalShowAction = typeActionCreator(IELTS_MODAL_SHOW);
export var ieltsModalHideAction = typeActionCreator(IELTS_MODAL_HIDE);